/**
 * Module Configuration
 * 
 * This file defines all product line modules in the platform.
 * Each module represents a distinct business area with its own admin interface.
 * 
 * Structure:
 * - id: Unique identifier for the module
 * - name: Display name
 * - icon: Lucide React icon component
 * - color: Theme color for the module
 * - path: Base route path
 * - description: Brief description
 * - enabled: Whether the module is currently enabled
 */

import {
  Shield,
  Calendar,
  MapPin,
  AlertCircle,
} from "lucide-react";

export const MODULE_IDS = {
  INSURANCE: "insurance",
  EVENTS_MEDIA: "events-media",
  TRAVEL_TOURS: "travel-tours",
  SAFETY_SERVICES: "safety-services",
};

export const MODULES = [
  {
    id: MODULE_IDS.INSURANCE,
    name: "Insurance Admin",
    shortName: "Insurance",
    icon: Shield,
    color: "blue",
    path: "/admin/insurance",
    defaultPath: "/admin/insurance",
    description: "Manage insurance policies, claims, and related operations",
    enabled: true,
    badge: "Soon",
  },
  {
    id: MODULE_IDS.EVENTS_MEDIA,
    name: "Events & Media Admin",
    shortName: "Events & Media",
    icon: Calendar,
    color: "emerald",
    path: "/admin/media",
    defaultPath: "/admin/media/events",
    description: "Manage events, conferences, trade missions, and media content",
    enabled: true,
  },
  {
    id: MODULE_IDS.TRAVEL_TOURS,
    name: "Travel, Tours & Logistics",
    shortName: "Travel & Tours",
    icon: MapPin,
    color: "purple",
    path: "/admin/travel",
    defaultPath: "/admin/travel", // Will be updated when travel routes are added
    description: "Manage tours, transportation, and logistics operations",
    enabled: true,
    badge: "Soon",
  },
  {
    id: MODULE_IDS.SAFETY_SERVICES,
    name: "Safety Services",
    shortName: "Safety",
    icon: AlertCircle,
    color: "orange",
    path: "/admin/safety",
    defaultPath: "/admin/safety", // Will be updated when safety routes are added
    description: "Manage safety services and related operations",
    enabled: true,
    badge: "Soon",
  },
];

/**
 * Get module by ID
 */
export const getModuleById = (id) => {
  return MODULES.find((module) => module.id === id);
};

/**
 * Get default module (first enabled module)
 */
export const getDefaultModule = () => {
  return MODULES.find((module) => module.enabled) || MODULES[0];
};

/**
 * Get enabled modules only
 */
export const getEnabledModules = () => {
  return MODULES.filter((module) => module.enabled);
};

